import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { CartService, CartRow, Product, CartRowPrice, Availability, PriceConfigService } from 'gung-standard';
import { ColmecAddonsCartService, AddOnsByProduct } from './../../../services/colmec-addons-cart.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';

export interface SalesCartRow {
  cartRow: CartRow;
  product: Product;
  price: CartRowPrice;
  availability?: Availability;
}

const buildExtraObjectWithValue = (value: any, pathStr: string): any => {
  const path = pathStr.split('.');
  const recursive = (current: {}, pathArr: string[], theValue: any) => {
    const [first, ...rest] = pathArr;
    if (!first) {
      return theValue;
    }
    current[first] = recursive({}, rest, theValue);
    return current;
  };
  return recursive({}, path, value);
};

const resolvePathValue = (value: {}, path: string[]): any | undefined => {
  const [first, ...others] = path;
  if (!first) {
    return value;
  }
  if (!value) {
    return undefined;
  }
  return resolvePathValue(value[first], others);
};

@Component({
    selector: 'colmec-sales-cart-row',
    templateUrl: './colmec-sales-cart-row.component.html',
    styleUrls: ['./colmec-sales-cart-row.component.scss'],
    standalone: false
})
export class ColmecSalesCartRowComponent extends ListItemRendererComponent<SalesCartRow> implements OnInit, OnDestroy {  protected cartService = inject(CartService);
  protected colmecAddonsCartService = inject(ColmecAddonsCartService);
  protected priceConfigService = inject(PriceConfigService);

  productAddons: AddOnsByProduct;
  private unsubscribe: Subject<void> = new Subject();
  hidePrice = false;

  ngOnInit(): void {
    this.priceConfigService.hidePrice.subscribe(hidePrice => (this.hidePrice = hidePrice));
    this.colmecAddonsCartService
      .getAddOnProductsByParentProduct()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(addOnsByProducts => {
        this.productAddons = addOnsByProducts.find(item => item.productId === this.data.product.id);
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public trackByAddon(index: number, item: any) {
    return index;
  }

  public removeRow(row: SalesCartRow) {
    this.cartService.removeRow(row.cartRow);
  }

  public orEmpty(value: {}, path: string) {
    const str = resolvePathValue(value, path.split('.'));
    return str || '';
  }

  public updateQty(row: SalesCartRow, value: any) {
    // check qty
    const oldQty = row.cartRow.qty;
    if (oldQty === value) {
      return;
    }
    // value has changed, propagate throught the cart
    this.cartService.setProductQuantity(row.cartRow.productId, value, row.cartRow.targetStockId);
  }

  public updateExtraField(row: SalesCartRow, value: any, path: string) {
    // TODO check if value is the same as before
    console.log('UPDATING EXTRA FIELD');
    if (value !== 0 && !value) {
      this.cartService.removeExtraField(row.cartRow.productId, path, row.cartRow.targetStockId);
      return;
    }
    const extraObj = buildExtraObjectWithValue(value, path);
    this.cartService.setExtra(row.cartRow.productId, extraObj, row.cartRow.targetStockId);
  }
}
